import * as React from 'react';
import { Alert, Button, Stack } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { SeoItem } from '../types';
import { formatTime } from './common';

// Where a change to an existing article stands: errors and warnings from the
// checks, live since when, or undone by whom.
export default function ChangeStatus({
  item,
  url,
}: {
  item: SeoItem;
  url: string;
}) {
  return (
    <Stack spacing={1}>
      {item.lastError && <Alert severity="error">{item.lastError}</Alert>}
      {item.validation.warnings.map(w => (
        <Alert key={w} severity="warning">
          {w}
        </Alert>
      ))}
      {item.validation.info.map(i => (
        <Alert key={i} severity="info">
          {i}
        </Alert>
      ))}
      {item.status === 'changes_requested' && (
        <Alert severity="info">
          Sent back: “{item.feedback}”. It will be redrafted on the next daily
          run.
        </Alert>
      )}
      {item.status === 'rejected' && (
        <Alert severity="info">
          Rejected{item.decidedBy ? ` by ${item.decidedBy}` : ''}
          {item.reason ? `: “${item.reason}”` : ''}.
        </Alert>
      )}
      {item.status === 'published' && (
        <Alert
          severity="success"
          action={
            <Button
              size="small"
              href={url}
              target="_blank"
              rel="noopener"
              endIcon={<OpenInNewIcon />}
            >
              Open
            </Button>
          }
        >
          Live since {formatTime(item.published!.publishedAt)}
          {item.decidedBy ? ` (${item.decidedBy})` : ''}.
          {item.published?.simulated
            ? ' (Simulated: not a production run.)'
            : ''}
        </Alert>
      )}
      {item.status === 'reverted' && (
        <Alert severity="info">
          Undone{item.revertedBy ? ` by ${item.revertedBy}` : ''}
          {item.revertedAt ? ` on ${formatTime(item.revertedAt)}` : ''}. The
          previous version is back.
        </Alert>
      )}
    </Stack>
  );
}
